module.exports = __webpack_public_path__ + "media/images/premium/plan-point-cbc03de8577fd0df2ec2f52815be72c1.svg";